import { useSearchParams } from "react-router-dom";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";

export default function ChatWindow() {
  const [searchParams] = useSearchParams();

  const contactId = searchParams.get("contactId");

  if (!contactId) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-500">
        Select a contact to start chatting
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col">
      <ChatHeader contactId={contactId} />

      {/* Chat Messages */}
      <ChatMessages contactId={contactId} />

      {/* Chat Input */}
      <ChatInput contactId={contactId} />
    </div>
  );
}
